// extracted by mini-css-extract-plugin
export default {"language-picker":"QtAEjtF","language-picker__visually-hidden":"tT_IzVp","language-picker__select":"yJebYhg","language-picker__icon":"zwvxSmM"};